/* unplugin-vue-components disabled */import script from "./event-text-media.vue?vue&type=script&lang=js"
export * from "./event-text-media.vue?vue&type=script&lang=js"

import "./event-text-media.vue?vue&type=style&index=0&id=778d18a9&lang=scss"

const __exports__ = script;

export default __exports__